function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevyzLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256.41 87.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.42,2.18A11.06,11.06,0,0,0,68.6,7.5a11.22,11.22,0,0,0,.21,10.05L55.2,27.14a15,15,0,0,1,1.73,2.25L70.4,19.9a11.21,11.21,0,1,0,13-17.72Z",
    style: {
      fill: "#0052cc",
      stroke: "#0052cc",
      strokeMiterlimit: 10,
      strokeWidth: "1.18344999055574px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.79,70A9.2,9.2,0,0,0,51,74a9.39,9.39,0,0,0,4.48,12.49,9.2,9.2,0,0,0,3.94.88,9.7,9.7,0,0,0,3.22-.56,9.35,9.35,0,0,0,.84-17.28,9.06,9.06,0,0,0-6.19-.62l-7.15-17.8a15.33,15.33,0,0,1-2.64.85Z",
    style: {
      fill: "#0052cc",
      stroke: "#0052cc",
      strokeMiterlimit: 10,
      strokeWidth: "1.18344999055574px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.06,42.22a8.59,8.59,0,0,0-4.22-4.42A8.55,8.55,0,0,0,1.45,41.88,8.59,8.59,0,0,0,1,48.3,8.1,8.1,0,0,0,5.31,53,8.58,8.58,0,0,0,16.7,49a8.09,8.09,0,0,0,.78-4.17L30,41.89a15.71,15.71,0,0,1-.58-2.53Z",
    style: {
      fill: "#0052cc",
      stroke: "#0052cc",
      strokeMiterlimit: 10,
      strokeWidth: "1.18344999055574px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.87,11.71A5.86,5.86,0,1,0,31,4a5.81,5.81,0,0,0,2.8,7.82,6.1,6.1,0,0,0,2.41.58l3,10.93a15.41,15.41,0,0,1,2.69-.7Z",
    style: {
      fill: "#0052cc",
      stroke: "#0052cc",
      strokeMiterlimit: 10,
      strokeWidth: "1.18344999055574px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.31,
    y: 22.4,
    width: 29.94,
    height: 29.94,
    rx: 14.97,
    transform: "translate(68.39 90.06) rotate(-154.75)",
    style: {
      fill: "#0052cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.32,36.94a12.75,12.75,0,0,0-2.55-.25c-4.34,0-8.1,2.1-8.1,8.87V59.92h-8.49V28.52h8.23v4.66c1.91-4.15,6.25-4.92,8.94-4.92.7,0,1.34.07,2,.13Z",
    style: {
      fill: "#0052cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.45,50.68c-1.58,5.37-6.5,9.85-14.14,9.85-8.53,0-16-6.12-16-16.61,0-9.92,7.33-16.36,15.29-16.36,9.6,0,15.35,6.13,15.35,16.11,0,1.2-.13,2.46-.13,2.59H135.54a7.57,7.57,0,0,0,7.83,7.07c3.91,0,6.06-1.2,7.07-4h7.26A8.23,8.23,0,0,1,157.45,50.68Zm-7.83-10.17c-.12-3.09-2.15-6.13-7-6.13a6.73,6.73,0,0,0-6.94,6.13Z",
    style: {
      fill: "#0052cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.13,59.92h-8.49l-12.83-31.4h9.32l7.79,21.06,7.89-21.06h8.94Z",
    style: {
      fill: "#0052cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.41,72.3l6.32-12.47L193.48,28.52H203l7.27,22.25,8.81-22.25h9.06L208.41,72.3Z",
    style: {
      fill: "#0052cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.44,59.92V52.45l14.87-16.59H230.82V28.52h25.34V35.6L240.84,52.52h15.57v7.4Z",
    style: {
      fill: "#0052cc"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevyzLogo);
export default __webpack_public_path__ + "static/media/revyz-logo.9889de4877642c195ac9e5e2bb8c8d5a.svg";
export { ForwardRef as ReactComponent };